import styled from 'styled-components'
import { device } from '../../../atoms/Utlis/media'
import {
  PageContainer,
  ScrollBody,
  FormCard,
  CardHeader,
  CardIcon,
  CardTitle,
  CardSubtitle,
  Field,
  Label,
  Input,
  ErrorSpan,
  RequiredStar,
  SubmitBar,
  SubmitHint,
  SubmitButton,
  DeleteBtn,
  gradient,
} from '../Member/memberFormStyles'

export {
  PageContainer,
  ScrollBody,
  FormCard,
  CardHeader,
  CardIcon,
  CardTitle,
  CardSubtitle,
  Field,
  Label,
  Input,
  ErrorSpan,
  RequiredStar,
  SubmitBar,
  SubmitHint,
  SubmitButton,
  DeleteBtn,
  gradient,
}

export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 20px;
  align-items: start;

  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`

export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 30px;

  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`

export const CoverUploadArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
`

export const CoverDropzone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 220px;
  padding: 20px;
  border-radius: 16px;
  border: 2px dashed rgba(201, 77, 170, 0.28);
  background: linear-gradient(
    180deg,
    rgba(201, 77, 170, 0.04) 0%,
    rgba(255, 201, 81, 0.04) 100%
  );
  transition: all 0.15s ease;

  &:hover {
    border-color: rgba(201, 77, 170, 0.45);
    transform: translateY(-1px);
  }
`

export const CoverHint = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #c94daa;
  text-align: center;
`

export const CoverSubhint = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.45);
  text-align: center;
`

export const CoverPreviewWrap = styled.div`
  position: relative;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
`

export const CoverPreview = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
  cursor: pointer;
`

export const RemoveCoverBtn = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: none;
  background: rgba(228, 72, 98, 0.92);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
`

export const FolderSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`

export const FolderCount = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
`

export const AddFolderBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 14px;
  border: none;
  border-radius: 10px;
  background: ${gradient};
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(201, 77, 170, 0.22);
  transition: transform 0.15s ease;
  &:hover { transform: translateY(-1px); }
`

export const FolderGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 16px;

  @media ${device.mobileL} {
    grid-template-columns: 1fr;
  }
`

export const HeroActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
`

export const HeroSaveBtn = styled(SubmitButton)`
  min-width: unset;
  height: 40px;
  padding: 0 18px;
  font-size: 14px;
`

export const HeroActionsSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
`
